import { QueryClientProvider, type QueryClient } from '@tanstack/react-query'
import { useState, type ReactNode } from 'react'
import { I18nextProvider } from 'react-i18next'
import i18n from '@/i18n'
import { createQueryClient } from '@/lib/query/queryClient'
import { ToastProvider } from '@/shared/ui/Toast'
import { AppErrorBoundary } from './AppErrorBoundary'

export interface AppProvidersProps {
  children: ReactNode
  /** Injected by tests so each case gets an isolated cache. */
  queryClient?: QueryClient
}

export function AppProviders({ children, queryClient }: AppProvidersProps) {
  const [client] = useState(() => queryClient ?? createQueryClient())

  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={client}>
        <ToastProvider>
          <AppErrorBoundary>{children}</AppErrorBoundary>
        </ToastProvider>
      </QueryClientProvider>
    </I18nextProvider>
  )
}
